import { adminActionTypes } from "src/action_types/section_action_types";

export function selectOrganizationIdAction(organizationId) {
  return {
    type: adminActionTypes.selectRulesOrganization,
    payload: organizationId
  };
}
